const RgpContent = () => {
    return (
        <>
            <h4>
                The Regular Giving Program Launch
            </h4>
            <p>
                The Regular Giving Program is launched, enabling supporters to donate to Breast Cancer Trials each month via an automated direct debit or credit card transaction. This program has over 1,800 members today.
            </p>
        </>
    );
}

export default RgpContent;